import type React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CustomForwardIconProps {
  expanded: boolean;
}

const CustomForwardIcon: React.FC<CustomForwardIconProps> = ({ expanded }) => {
  return (
    <ExpandMoreIcon
      sx={{
        marginLeft: 'auto',
        width: '20px',
        height: '20px',
        transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
        fill: 'rgba(0, 40, 58, 0.56)',
      }}
    />
  );
};

export default CustomForwardIcon;
